import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MobileHeaderOnly from "components/headers/light.js";
import DownLoadApp from "salad/DownLoadApp";
import GrainFooter from "salad/GrainFooter";

export default () => (
    <div style={{ backgroundColor: "#FFFBDC", minHeight: "100vh" }}>
        <MobileHeaderOnly />
        <AnimationRevealPage>
            <DownLoadApp />
            <GrainFooter />
        </AnimationRevealPage>
    </div>
);
